export { SessionManager };

const SessionManager = function() {
	let self = this;

	this.timeout = 86400; // 60 min (60 * 60) = 3600 seconds;
	this.final_timeout = 600; // 5 min (60 * 5) = 300 seconds
	this.ta = null;
	this.tt = null;
	this.tc = 0;

	this.countDownInterval = function () {
		self.tc--;
		console.log("countDownInterval", self.tc);


		if (self.tc > 60) {
			let rc = Math.floor(self.tc / 60);

			$(".session-time-left").html(rc + " min");
		} else {
			$(".session-time-left").html(self.tc + " sekundi");
		}

		if (self.tc <= 0) {
			self.endCountDown();
			endSession(1);
		}
	};

	this.startCountDown = function () {
		console.log("startCountDown", self.final_timeout);

		let mins = this.final_timeout / 60;
		$(".session-time-left").html(mins + " min");

		if (self.tt) {
			clearInterval(self.tt);
			self.tt = null;
		}
		self.tc = self.final_timeout;
		self.tt = setInterval(self.countDownInterval, 1000);
	};

	this.endCountDown = function () {
		console.log("endCountDown");

		if (self.tt) {
			clearInterval(self.tt);
			self.tt = null;
		}
	};

	this.showSessionWarning = function () {
		console.log("showSessionWarning");

		$(".modal").hide();
		$(".modal-overlay").show();
		$("[data-modal='timeout']").show();
		$("body").addClass("modal-opened");

		self.startCountDown();
	};
	this.closeSessionWarning = function () {
		console.log("closeSessionWarning");

		$(".modal").hide();
		$(".modal-overlay").hide();
		$("body").removeClass("modal-opened");

		self.endCountDown();
	};

	this.reset = function () {
		console.log("reset");

		self.endCountDown();
		self.startTimer();
	};

	this.disable = function () {
		console.log("disable");

		self.timeout = 86400; // 24h (60 * 60 * 24) = 86400 seconds;
		self.reset();
	};

	this.startTimer = function () {
		console.log("startTimer", self.ta, (self.timeout * 1000));
		if (self.ta) {
			clearTimeout(self.ta);
			self.ta = null;
		}
		self.ta = setTimeout(self.showSessionWarning, (self.timeout * 1000));
	};

	this.startTimer();

	console.log("SessionManager instantiated", this.timeout);

	function endSession(auto) {
		console.log("endSession", auto);
		//document.location = "/index.php?lahku=1&f=minu_andmed" + (auto ? "&automaatne=1" : "");
	}

	function continueSession() {
		console.log("continueSession");
		self.endCountDown();

		$.get("/ping", function () {
			self.closeSessionWarning();
			self.startTimer();
		});
	}

	$(document).on("click", ".end-session", function () {
		console.log("click .end-session");
		endSession();
		return false;
	});
	$(document).on("click", ".continue-session", function () {
		console.log("click .continue-session");

		continueSession();
		return false;
	});
}